import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { IClass } from 'src/app/admin/class/model/class.model';
import { take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  class: IClass;

  constructor(
    private af: AngularFirestore
  ) {
    // this.loadDefaultSetting();
  }

  getClass() {
    return this.class;
  }

  loadDefaultSetting() {
    this.getActiveClass()
      .subscribe(data => {
        // console.log('loadDefaultSetting', data[0]);
        this.class = data[0];
      });
  }

  getActiveClass() {
    // return this.af.collection<IClass>('classes')
    return this.af.collection<IClass>('classes', ref => ref.where('isDefault', '==', true))
      .snapshotChanges()
      .pipe(
        map(rows => {
          return rows.map(row => {
            const data = row.payload.doc.data();
            data.id = row.payload.doc.id;
            return data;
          });
        }),
        take(1)
      );
  }
}
